<div class="add-permisiune-container">
  <h1 class="solcitare-title">Adaugă permisiune</h1>
  <form
    class="add-permisiune-card__form"
    [formGroup]="form"
    (submit)="submitForm()"
  >
    <div class="add-permisiune-field">
      <mat-form-field appearance="fill">
        <mat-label>Nume</mat-label>
        <input type="text" matInput formControlName="name" />
        <mat-error
          *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>
    <div class="add-permisiune-field">
      <div class="spinner">
        <mat-spinner color="primary" *ngIf="isSectionsLoading"></mat-spinner>
      </div>
      <mat-form-field *ngIf="!isSectionsLoading" appearance="fill">
        <mat-label>Secțiuni</mat-label>
        <mat-select formControlName="section_id">
          <mat-option *ngFor="let section of sections$ | async" [value]="section.id">
            {{ section.name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            !form.controls['section_id'].valid &&
            form.controls['section_id'].touched
          "
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>
    <div class="spinner">
      <mat-spinner color="primary" *ngIf="isLoading"></mat-spinner>
    </div>
    <div class="add-permisiune-action-btns">
      <button
        class="buttons"
        mat-flat-button
        type="button"
        (click)="closeDialog()"
      >
        Close
      </button>
      <button
        class="buttons"
        mat-flat-button
        type="submit"
        color="primary"
        [disabled]="form.invalid"
      >
        Save
      </button>
    </div>
  </form>
</div>
